import React from 'react';

const weekdayLabels = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

const formatDateKey = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

function Calendar({ monthDate, events, selectedDate, onDateSelect }) {
  const year = monthDate.getFullYear();
  const month = monthDate.getMonth();
  const firstDay = new Date(year, month, 1).getDay();
  const daysInMonth = new Date(year, month + 1, 0).getDate();

  const dayCells = [];
  for (let i = 0; i < firstDay; i += 1) {
    dayCells.push(<div key={`blank-${i}`} className="calendar-cell empty" />);
  }

  for (let day = 1; day <= daysInMonth; day += 1) {
    const date = new Date(year, month, day);
    const dateKey = formatDateKey(date);
    const dayEvents = events[dateKey] || [];
    const isSelected = dateKey === selectedDate;

    dayCells.push(
      <button
        key={dateKey}
        className={`calendar-cell day ${isSelected ? 'selected' : ''}`}
        onClick={() => onDateSelect(dateKey)}
        type="button"
      >
        <span className="date-number">{day}</span>
        {dayEvents.length > 0 && <span className="event-count">{dayEvents.length} appointment{dayEvents.length > 1 ? 's' : ''}</span>}
      </button>
    );
  }

  return (
    <div className="calendar-wrapper">
      <div className="calendar-grid labels">
        {weekdayLabels.map((label) => (
          <div key={label} className="calendar-cell label">
            {label}
          </div>
        ))}
      </div>
      <div className="calendar-grid days">{dayCells}</div>
    </div>
  );
}

export default Calendar;
